import React from "react";
import { useAuth } from "../context/AuthContext";

// Component to show subscription status
const SubscriptionBadge: React.FC = () => {
  const { user, isPremiumUser, getPlanName } = useAuth();

  if (!user) {
    return null;
  }

  // Get formatted date if plan_started_at exists
  const formatDate = (dateString?: string) => {
    if (!dateString) return "N/A";
    return new Date(dateString).toLocaleDateString();
  };

  // Plan name mapping
  const planNameMap: Record<string, string> = {
    basic: "Starter",
    pro: "Business",
    enterprise: "Growth",
  };

  const planName = getPlanName();
  const displayName = planName ? planNameMap[planName] || planName : "Free";

  // Different styles based on plan tier
  const getBadgeStyles = () => {
    if (!isPremiumUser()) {
      return "bg-gray-100 text-gray-800";
    }

    switch (planName) {
      case "enterprise":
        return "bg-purple-100 text-purple-800 border-purple-300";
      case "pro":
        return "bg-blue-100 text-blue-800 border-blue-300";
      case "basic":
      default:
        return "bg-green-100 text-green-800 border-green-300";
    }
  };

  return (
    <div className="flex flex-col space-y-1">
      <div className="flex items-center">
        <span className="text-sm text-gray-500 mr-2">Subscription:</span>
        <span
          className={`text-xs px-2 py-1 rounded-full font-medium border ${getBadgeStyles()}`}
        >
          {displayName} Plan
        </span>
      </div>
      {isPremiumUser() && (
        <div className="text-xs text-gray-500">
          Active since: {formatDate(user.plan_started_at)}
        </div>
      )}
      <div className="font-medium text-blue-600">
        {user.videos_left} video credits available
      </div>
    </div>
  );
};

export default SubscriptionBadge;
